import { Box, Tab, Typography } from '@mui/material';
import React from 'react';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const VemigoTabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 6, padding: '0'}}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

export const generateTabs = (tabLabels, value, activeTabStyle) => {
  return tabLabels.map(({ id, label, page }) => (
    <Tab
      key={id}
      label={label}
      {...a11yProps(id)} 
      style={value === (id) ? activeTabStyle : {}}
      sx={{borderRight: '1px solid #ccc' }}
    />
  ));
};

export const generateTabPanels = (tabLabels, value) => {
  return tabLabels.map(({ id, page }) => (
    <VemigoTabPanel key={id} value={value} index={id}>
      {page}
    </VemigoTabPanel>
  ));
};

